import React from 'react';

const EqualOpportunityPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-[#FFF4E6] to-[#FAFAF8]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-4">
              Equal Opportunity Statement
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            
            <div className="bg-[#FAFAF8] rounded-2xl p-8 md:p-12 border border-gray-100">
              <p className="text-[#6B7280] leading-relaxed text-lg mb-6">
                TekClap is committed to providing equal opportunity in all aspects of engagement, including hiring, partnerships, and client services.
              </p>
              
              <p className="text-[#6B7280] leading-relaxed text-lg mb-6">
                We do not discriminate based on race, color, religion, gender, gender identity, sexual orientation, age, disability, veteran status, national origin, or any other protected characteristic under applicable law.
              </p>
              
              <p className="text-[#6B7280] leading-relaxed text-lg mb-6">
                We believe that diversity strengthens our organization and enables us to better serve our clients. We are committed to fostering an inclusive environment where all individuals are treated with dignity and respect.
              </p>
              
              <p className="text-[#6B7280] leading-relaxed text-lg">
                If you have questions or concerns regarding our equal opportunity practices, please contact us at{' '}
                <a href="mailto:info@tekclap.com" className="text-[#F58B23] hover:underline">info@tekclap.com</a>.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default EqualOpportunityPage;
